// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Breadcrumbs from "@insite/mobius/Breadcrumbs";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";

import { SectionTitle } from "@hardwoods/App/Widgets/DesignSystem/DesignSystem";
import { generateDynamicGridItemStyle } from "@hardwoods/App/Widgets/DesignSystem/DesignSystem.utils";
import { dummyLinks } from "@hardwoods/App/Widgets/DesignSystem/DummyData";
import MlBreadcrumbs from "@insite/mobius/Breadcrumbs";
import React from "react";

export const XdlBreadcrumbs = () => {
    return (
        <>
            <GridContainer>
                <SectionTitle title="From Title" />
                <GridItem {...generateDynamicGridItemStyle(1)}>
                    <MlBreadcrumbs links={dummyLinks.slice(0, 4)} />
                </GridItem>
                <GridItem {...generateDynamicGridItemStyle(1)}>
                    <MlBreadcrumbs links={dummyLinks} />
                </GridItem>

                <SectionTitle title="From Mobius" />
                <GridItem {...generateDynamicGridItemStyle(1)}>
                    <Breadcrumbs links={dummyLinks.slice(0, 4)} />
                </GridItem>
                <GridItem {...generateDynamicGridItemStyle(1)}>
                    <Breadcrumbs links={dummyLinks} />
                </GridItem>
            </GridContainer>
        </>
    );
};
